module.exports = __webpack_public_path__ + "static/img/zc_indicator.png";